import * as React from 'react';

const UNSAFE_TAG_PATTERN = /<\/?(?:base|embed|frame|iframe|link|meta|object|script|style)(?:\s[^>]*)?>/gi;
const INLINE_EVENT_PATTERN = /\son[a-z]+\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]+)/gi;
const UNSAFE_PROTOCOL_PATTERN = /\s(href|src)\s*=\s*(["'])?\s*(?:javascript|vbscript):[^\s>]*\2?/gi;

export const sanitizeCmsHtml = html => {
  if (typeof html !== 'string') {
    return '';
  }

  return html
    .replace(UNSAFE_TAG_PATTERN, '')
    .replace(INLINE_EVENT_PATTERN, '')
    .replace(UNSAFE_PROTOCOL_PATTERN, '');
};

const CmsRichText = ({ className, html }) => {
  const sanitizedHtml = sanitizeCmsHtml(html);

  if (!sanitizedHtml) {
    return null;
  }

  return <div className={className} dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />;
};

CmsRichText.defaultProps = {
  className: undefined,
  html: ''
};

export default CmsRichText;
